import React from "react"
import { useDropzone, FileWithPath } from "react-dropzone"
import {
  Box,
  FormControl,
  InputLabel,
  ListItem,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material"
import { ImageType } from "@/common/globals"
import { ImageOrientationEnum } from "@/common/types"

export default function FileUploader({
  horizontalFiles,
  setHorizontalFiles,
  verticalFiles,
  setVerticalFiles,
}: {
  horizontalFiles: ImageType[]
  setHorizontalFiles: React.Dispatch<React.SetStateAction<ImageType[]>>
  verticalFiles: ImageType[]
  setVerticalFiles: React.Dispatch<React.SetStateAction<ImageType[]>>
}) {
  const onHorizontalDrop = (acceptedFiles: FileWithPath[]) => {
    const newImages = acceptedFiles.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      order: horizontalFiles.length + 1,
      orientation: ImageOrientationEnum.HORIZONTAL,
    }))

    setHorizontalFiles((prev) => [...prev, ...newImages])
  }
  const onVerticalDrop = (acceptedFiles: FileWithPath[]) => {
    const newImages = acceptedFiles.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      order: verticalFiles.length + 1,
      orientation: ImageOrientationEnum.VERTICAL,
    }))

    setVerticalFiles((prev) => [...prev, ...newImages])
  }

  const handleHorizontalOrderChange = (index: number, newOrder: string) => {
    const updatedImages = [...horizontalFiles]
    updatedImages[index].order = parseInt(newOrder, 10)
    setHorizontalFiles(updatedImages)
  }
  const handleVerticalOrderChange = (index: number, newOrder: string) => {
    const updatedImages = [...verticalFiles]
    updatedImages[index].order = parseInt(newOrder, 10)
    setVerticalFiles(updatedImages)
  }

  const {
    getRootProps: getHorizontalRootProps,
    getInputProps: getHorizontalInputProps,
  } = useDropzone({
    onDrop: onHorizontalDrop,
    disabled: horizontalFiles.length >= 3,
  })
  const {
    getRootProps: getVerticalRootProps,
    getInputProps: getVerticalInputProps,
  } = useDropzone({
    onDrop: onVerticalDrop,
    disabled: verticalFiles.length >= 3,
  })

  const horizontalFilesList =
    horizontalFiles &&
    horizontalFiles.map((file, index) => (
      <ListItem
        key={file.file.name}
        sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}
      >
        {file.file.name}
        <Box width="50%">
          <FormControl fullWidth>
            <InputLabel>Order</InputLabel>
            <Select
              label="Order"
              onChange={(e) => {
                handleHorizontalOrderChange(index, String(e.target.value))
              }}
              sx={{ minWidth: "30%" }}
            >
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </ListItem>
    ))

  const verticalFilesList =
    verticalFiles &&
    verticalFiles.map((file, index) => (
      <ListItem
        key={file.file.name}
        sx={{ width: "100%", display: "flex", justifyContent: "space-between" }}
      >
        {file.file.name}
        <Box width="50%">
          <FormControl fullWidth>
            <InputLabel>Order</InputLabel>
            <Select
              label="Order"
              onChange={(e) => {
                handleVerticalOrderChange(index, String(e.target.value))
              }}
              sx={{ minWidth: "30%" }}
            >
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </ListItem>
    ))

  return (
    <section>
      <h4>Files</h4>
      <Stack direction="row" width="100%" spacing={2}>
        <Stack width="100%">
          <Typography variant="h4">Horizontal</Typography>
          <div
            {...getHorizontalRootProps()}
            style={{
              border: "2px dashed #000",
              padding: "20px",
              cursor: "pointer",
            }}
          >
            <input {...getHorizontalInputProps()} />
            {horizontalFiles.length >= 3 ? (
              <p>Maximum files added</p>
            ) : (
              <p>Drag 'n' drop some files here, or click to select files</p>
            )}
          </div>
          <Stack width="100%">{horizontalFilesList}</Stack>
        </Stack>
        {/* <p>{files}</p> */}
        <Stack width="100%">
          <Typography variant="h4">Vertical</Typography>
          <div
            {...getVerticalRootProps()}
            style={{
              border: "2px dashed #000",
              padding: "20px",
              cursor: "pointer",
            }}
          >
            <input {...getVerticalInputProps()} />
            {verticalFiles.length >= 3 ? (
              <p>Maximum files added</p>
            ) : (
              <p>Drag 'n' drop some files here, or click to select files</p>
            )}
          </div>
          <Stack width="100%">{verticalFilesList}</Stack>
        </Stack>
      </Stack>
    </section>
  )
}
